import { baseUrl } from "../../../../../baseUrl";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fetchWithAuthHandling } from "../../../../../authHandling";
import { DocumentRow } from "../../../../../components/buyers/documents/documentRow";
import type { FilesInterface } from "../../../../../interfaces/mortgageDetailsInterface";
import {
  Box,
  Table,
  Paper,
  Alert,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  CircularProgress
} from "@mui/material";

export const Route = createFileRoute(
  "/_app/buyers/$buyerId/_buyerLayout/documents"
)({
  loader: ({ params }) => {
    const { buyerId } = params;
    return { buyerId };
  },
  component: documentTab
});

function documentTab() {
  const { buyerId } = Route.useLoaderData();

  const {
    data: buyerData,
    isLoading,
    error
  } = useQuery({
    queryKey: ["buyerDocuments", buyerId],
    queryFn: async () => {
      const response = await fetchWithAuthHandling(
        `${baseUrl}/buyers/${buyerId}/files`,
        {
          method: "GET",
          credentials: "include"
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch buyer data");
      }
      const data = await response.json();
      return data;
    }
  });

  return (
    <Container
      sx={{
        my: 5,
        maxWidth: {
          xs: "97%"
        }
      }}
    >
      {!isLoading && error && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No User Data Found
          </Typography>
        </Box>
      )}
      {isLoading && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!isLoading && !error && buyerData && (
        <Paper elevation={4} sx={{ p: 2, mt: 2 }}>
          <Typography variant="h6" sx={{ pb: 2 }}>
            Documents
          </Typography>
          {buyerData.files.length > 0 ? (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Document Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {buyerData.files.map((file: FilesInterface) => (
                    <DocumentRow key={file.id} files={file} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Alert severity="error">No Documents Provided</Alert>
          )}
        </Paper>
      )}
    </Container>
  );
}
